import React from "react"
import { TimerContext } from "@layerhub-io/use-timer"
import { Block } from "baseui/block"
import Pause from "~/components/Icons/Pause"
import PlaySolid from "~/components/Icons/PlaySolid"
import useDesignEditorContext from "~/hooks/useDesignEditorContext"

export default function () {
  const { pause, status, time, setTime } = React.useContext(TimerContext)
  const { displayAnimation, setDisplayAnimation, animationPlaying, setAnimationPlaying, maxTime } =
    useDesignEditorContext()

  const toggle = () => {
    if (!displayAnimation) {
      // Play always runs the HyperFrames animation preview; otherwise the
      // multi-scene playback looks broken (static frame / no timeline sync).
      pause()
      if (maxTime && time >= maxTime && typeof setTime === "function") setTime(0)
      setDisplayAnimation(true)
      setAnimationPlaying(true)
      return
    }

    if (animationPlaying) {
      setAnimationPlaying(false)
    } else {
      if (maxTime && time >= maxTime && typeof setTime === "function") setTime(0)
      setAnimationPlaying(true)
    }
  }

  const showPause = displayAnimation ? animationPlaying : status !== "STOPPED" && status !== "PAUSED"

  return (
    <Block id={"EditorPlayControl"} $style={{ padding: "0 1rem" }}>
      <Block
        onClick={toggle}
        $style={{
          height: "56px",
          width: "56px",
          background: "#ffffff",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: "0 0 0 1px rgba(64,87,109,0.07),0 2px 12px rgba(53,71,90,0.2)",
        }}
      >
        {showPause ? <Pause size={24} /> : <PlaySolid size={24} />}
      </Block>
    </Block>
  )
}
